varying vec2 vUv;



precision mediump float;

void main() {
    #include <colorspace_fragment>
    gl_FragColor = vec4(vUv, 0.0, 1.0);
}
